module.exports = __webpack_public_path__ + "img/main_3_1_1.0b884596.png";